import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Routes, Route, Link } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { GetSmsCampaignView } from "../Features/smscampaign/Smscampaignview";
import { RootState, AppDispatch } from "../Appstore/store";
import { formatDate } from "../helper";
import { setIsLoading } from "../Features/loadingSlice";
import ListTab from "./Listtab";
import Shortcuts from "./Shortcuts";
import { toast } from "sonner";
import HelpText from "./HelpText";

interface User {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  role: number;
}

interface sms_gateways_numbers {
  gateway_number: number;
  sms_gateway: {
    name: string;
  }[];
}

interface smsCampaignDatatype {
  sms_gateways_numbers: sms_gateways_numbers[];
  users: User[];
  name: string;
  createdAt: string;
  updatedAt: string;
  sms_campaign_numbers: {
    sms_gateway_id: number;
    sms_gateway_number_id: number;
  }[];
  sms_campaign_users: number | any;
}

function Viewsmscampaigns() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [toastShown, setToastShown] = useState(false);
  const { id }: any = useParams();

  const { loading, smscampaignviewsdata, error } = useSelector((state: RootState) => state.smscampaignview);

  const record: smsCampaignDatatype | any = smscampaignviewsdata.find(
    (gateway) => gateway.id === Number(id)
  );

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(GetSmsCampaignView(id))
        .unwrap()
        .catch((err) => {
          // console.error("Error fetching SMS gateway:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (error && !toastShown) {
      setToastShown(true);
      toast.error("No record found for this campaign list.");
      navigate("/admin/sms-campaigns");
    }
  }, [error, toastShown]);


  if (!record) {
    return (
      <>
        <div></div>
      </>
    );
  }

  return (
    <Routes>
      <Route
        path="details"
        element={<DetailsTab record={record} loading={loading} error={error} />}
      />
      <Route path="list" element={<ListTab record={record} />} />
      <Route path="shortcuts" element={<Shortcuts record={record} />} />
    </Routes>
  );
}

const DetailsTab = ({
  record,
  loading,
  error,
}: {
  record: smsCampaignDatatype;
  loading: boolean;
  error: string | null;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">View SMS Campaign</h2>
                  <button
                    onClick={() => navigate(-1)}
                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                  >
                    <IoMdArrowRoundBack /> Back
                  </button>
                </div>

                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <div className="px-3 py-3">
                      <div className="card-body px-0 py-0">
                        <div className="table-responsive">
                          <table className="table mb-0 table-bordered">
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={2} height={100}>
                                    <div className="text-center">
                                      <div className="loader"></div>
                                    </div>
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td colSpan={2} height={50}>
                                    <div className="text-center">
                                      <p className="mb-0 fs-5 fw-semibold">
                                        No data found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  <tr>
                                    <th
                                      className="p-3 fw-bold"
                                      style={{ width: 150 }}
                                    >
                                      Campaign Name
                                    </th>
                                    <td className="p-3">{record.name}</td>
                                  </tr>
                                  <tr>
                                    <th
                                      className="p-3 fw-bold"
                                      style={{ width: 150 }}
                                    >
                                      Created At
                                    </th>
                                    <td className="p-3">
                                      {formatDate(record.createdAt)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th
                                      className="p-3 fw-bold"
                                      style={{ width: 150 }}
                                    >
                                      Updated At
                                    </th>
                                    <td className="p-3">
                                      {formatDate(record.updatedAt)}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>

                          <h4 className="mt-4 mb-2">Users</h4>
                          <table className="table table-hover table-bordered text-nowrap">
                            <thead>
                              <tr>
                                <th className="ps-3 sr-no">SR No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th className="text-center">Role</th>
                                <th className="text-center action">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={6} height={100}>
                                    <div className="text-center">
                                      <div className="loader"></div>
                                    </div>
                                  </td>
                                </tr>
                              ) : record.users && record.users.length === 0 ? (
                                <tr>
                                  <td colSpan={6} height={50}>
                                    <div className="text-center">
                                      <p className="mb-0 fs-5 fw-semibold">
                                        No data found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                record?.users &&
                                record?.users.map(
                                  (item: any, index: number) => (
                                    <tr key={item.id}>
                                      <td className="ps-3">{index + 1}</td>
                                      <td>{item.name}</td>
                                      <td>{item.email}</td>
                                      <td>{item.phone_number}</td>
                                      <td className="p-3 text-center">
                                        {item.role === 1
                                          ? "Agents"
                                          : "Monitors"}
                                      </td>
                                      <td className="text-center">
                                        <Link
                                          to={`/admin/users/view/${item.id}`}
                                        >
                                          <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                            <i data-tooltip-id={"View_Btn_"+index} className="fa-solid fa-eye"></i>
                                            <HelpText id={"View_Btn_"+index} content="View User"/>
                                          </button>
                                        </Link>
                                      </td>
                                    </tr>
                                  )
                                )
                              )}
                            </tbody>
                          </table>

                          <h4 className="mt-4 mb-2">SMS Gateways Numbers</h4>
                          <table className="table table-hover table-bordered text-nowrap">
                            <thead>
                              <tr>
                                <th className="ps-3 sr-no">SR No</th>
                                <th>Sms Gateway Name</th>
                                <th>Gateway Number</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} height={100}>
                                    <div className="text-center">
                                      <div className="loader"></div>
                                    </div>
                                  </td>
                                </tr>
                              ) : record.sms_gateways_numbers &&
                                record.sms_gateways_numbers.length === 0 ? (
                                <tr>
                                  <td colSpan={3} height={50}>
                                    <div className="text-center">
                                      <p className="mb-0 fs-5 fw-semibold">
                                        No data found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                record?.sms_gateways_numbers &&
                                record?.sms_gateways_numbers.map(
                                  (item: any, index: number) => (
                                    <tr key={item.id}>
                                      <td className="ps-3">{index + 1}</td>
                                      <td>{item.sms_gateway.name}</td>
                                      <td>{item.gateway_number}</td>
                                    </tr>
                                  )
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Viewsmscampaigns;
